import { Bars3Icon, BellIcon } from '@heroicons/react/24/solid';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import objectPath from "object-path";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import KTToggle from "../../_assets/js/toggle";
import * as builder from "../../ducks/builder";
import { LayoutContextConsumer } from "../LayoutContext";

// Componente Funcional HeaderMobile
function HeaderMobile(props) {
	const toggleButtonRef = useRef(null);
	const [showSearch, setShowSearch] = useState(false);
	const [nova, setNova] = useState(false);

	useEffect(() => {
		//TODO buscar notificação
		setNova(true);
	}, []);

	useEffect(() => {
		if (toggleButtonRef.current && props.toggleOptions) {
			new KTToggle(toggleButtonRef.current, props.toggleOptions);
		}
	}, [props.toggleOptions]);

	const { asideDisplay, headerMobileCssClasses, headerMobileAttributes } = props;

	return (
		<LayoutContextConsumer>
			{({ subheader: { title, crumbMobile } }) => (
				<>
					<div
						id="kt_header_mobile"
						className={`kt-header-mobile ${headerMobileCssClasses}`}
						{...headerMobileAttributes}
					>
						<div className="left">
							<button
								className="header-mobile-toggle"
								id="kt_aside_mobile_toggler"
							>
								<Bars3Icon className="header-mobile-icon" />
							</button>



							{title && (
								<div className="header-mobile-title">
									{crumbMobile && <span className='crumb'>{crumbMobile}</span>}

									<span>{title}</span>
								</div>
							)}
						</div>

						<div className="right">
							<button type='button' className='notificacoes bell-notificacao'>
								<BellIcon />
								{nova && <div className="nova-not"></div>}
							</button>
						</div>
					</div>
				</>
			)}
		</LayoutContextConsumer>
	);
}

// Mapeamento de estado para propriedades (não precisa ser alterado)
const mapStateToProps = (store) => ({
	headerLogo: builder.selectors.getStickyLogo(store),
	asideDisplay: objectPath.get(store.builder.layoutConfig, "aside.self.display"),
	headerMenuSelfDisplay: objectPath.get(store.builder.layoutConfig, "header.menu.self.display") === true,
	toggleOptions: {
		target: "body",
		targetState: "kt-header__topbar--mobile-on",
		togglerState: "kt-header-mobile__toolbar-topbar-toggler--active",
	},
	headerMobileCssClasses: builder.selectors.getClasses(store, {
		path: "header_mobile",
		toString: true,
	}),
	headerMobileAttributes: builder.selectors.getAttributes(store, {
		path: "aside_menu",
	}),
});

// Exporta o componente conectado
export default connect(mapStateToProps)(HeaderMobile);